module.exports = __webpack_public_path__ + "img/075.1452ca60.png";